<template>
    <div class="escrow-officer-alert">
        <b-alert :show="showAlert" class="alert-banner">
            <b-row>
                <b-col cols="12" md="10">
                    <p><i class="fa-sharp fa-solid fa-circle-exclamation"></i> Your seller has reserved Home Sale Legal Protection&trade; for <b>{{ propertyAddress }}</b></p>                
                </b-col>
                <b-col cols="12" md="2">
                    <button class="gold-button" @click="openModal">
                        Add Escrow Officer
                    </button>
                </b-col>
            </b-row>
        </b-alert>
    </div>
</template>
<script>
import './EscrowOfficerAlert.scss'
import OrderAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource';
import EscrowOfficerAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/EscrowOfficerAppResource';
import {propertyStreetAddress,payAtClose} from '@helpers/order';
export default {
    name: 'EscrowOfficerAlert',
    props:{
        orderAppResource:{
            type: OrderAppResource,
            require: true
        }
    },
    computed:{
        showAlert(){
            return payAtClose(this.orderAppResource) && this.missingInformation;
        },
        propertyAddress(){
            return propertyStreetAddress(this.orderAppResource);
        },
        escrowOfficer(){
            return this.orderAppResource.escrowOfficer;
        },
        closingDate(){
            return this.orderAppResource.closingDate;
        },
        missingInformation(){
            return Boolean((this.escrowOfficer && !this.escrowOfficer.fullName && !this.escrowOfficer.email) || !this.closingDate || !this.escrowOfficer);
        }
    },
    methods:{
        openModal(){
            return this.$emit('show-modal', this.orderAppResource);
        }
    }
}
</script>
